import { modals } from "@mantine/modals";
import { Text } from "@mantine/core";

interface ConfirmationModalArgs {
  title?: string;
  message?: string;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
}

export const openConfirmationModal = (args: ConfirmationModalArgs) => {
  const title = args.title ?? "Please confirm";
  const message = args.message ?? (
    <Text size="sm">Please confirm your action.</Text>
  );
  const confirm = args.confirmLabel ?? "Confirm";
  const cancel = args.confirmLabel ?? "Cancel";
  modals.openConfirmModal({
    title,
    children: <Text size="sm">{message}</Text>,
    labels: { confirm, cancel },
    onConfirm: () => args.onConfirm(),
  });
};
